import { Goal,LoaderCircle } from 'lucide-react';
import React,{ useState,useEffect } from 'react';
import { fetchHighRiskPatientsInfoSingleMonth } from "../../services/patients";

export default function HighRiskCard(props) {
  const {account_id,location_id} = props

  const currentDate = new Date();
  const currentMonth = currentDate.getMonth()+1; 
  const currentYear = currentDate.getFullYear();
  const [selectedMonth, setSelectedMonth] = useState(Number(currentMonth));
  const [HRPatientsInfo, setHRPatientsInfo] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    loadHRPatientsInfo(account_id,location_id);
  },[account_id, location_id]);

  const loadHRPatientsInfo = async(account_id, location_id, month=selectedMonth, year=currentYear) => {
    try {
      const res = await fetchHighRiskPatientsInfoSingleMonth(account_id,location_id,month,year);
      if (res){
        if(res?.detail) {
          setHRPatientsInfo([]);
          console.log("🚀 ~ loadHRPatientsInfo ~ error:", res);
        } else {
          setHRPatientsInfo(res.data);
        }
      }
    } catch (error) {
      setHRPatientsInfo([]);
      // console.log("🚀 ~ loadHRPatientsInfo ~ error:", error);
    } finally {
      setIsLoading(false);
    }
  }
    
  const calculateRevinuePercentage = ((HRPatientsInfo.earned_revenue_from_visits * 100)/HRPatientsInfo.expected_total_revenue);
  const revinuePercentage = isNaN(calculateRevinuePercentage) ? "0.00" : calculateRevinuePercentage.toFixed(2);
  const calculateHighRiskPatientPercentage = ((HRPatientsInfo.high_risk_patients_visited * 100)/HRPatientsInfo.total_high_risk_patients);
  const highRiskPatientPercentage = isNaN(calculateHighRiskPatientPercentage) ? "0.00" : calculateHighRiskPatientPercentage.toFixed(2);

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const changeMonth = (e) => {
    setIsLoading(true);
    let mon = Number(e.target.value)
    setSelectedMonth(mon);
    loadHRPatientsInfo(account_id, location_id,mon)
  };

  return (
    <div className="highrisk_border_card">
      {isLoading ? (
        <div className="flex items-center loading" style={{ width: '100%', height: '100%', minHeight: '200px', justifyContent: 'center', background: 'var(--white)', borderRadius: '12px' }}>
          <span className="docpro_loading" style={{ position: 'inherit' }}>
            <LoaderCircle width={40} height={40} style={{color:"#369eff"}} />
          </span>
        </div>
      ) : (
        <>
          <div className="highrisk_card_top">
            <h3 className="docpro_fs_14 docpro_mb_0 docpro_mr_0"> {highRiskPatientPercentage ? highRiskPatientPercentage :0}% high-risk patient visited in 
              <select className='highrisk_month' value={selectedMonth} onChange={changeMonth}>
                {monthNames.map((month, index) => (
                  <option key={index} value={index + 1}>
                    {month}
                  </option>
                ))}
              </select>
            </h3>
            <div className='docpro_highrisk_tooltip message_header_tooltip relative'>
              <p>See how we calculate this?</p>
              <span className="docpro_tip">Ratio of revenue from high-risk patient visits to <br /> projected revenue of non-visiting high-risk patients.</span>
            </div>
          </div>
          <div className="highrisk_progress ">
            <div
              className="highrisk_progress_in"
              style={{ width: `${revinuePercentage ? revinuePercentage : 0}%` }}
            >
              <span>{revinuePercentage ? revinuePercentage : 0}%</span>
            </div>
          </div>
          <div className="highrisk_progress_bottom">
            <p>Reimbursement earned in {monthNames[selectedMonth-1]} approx: <span>${HRPatientsInfo?.earned_revenue_from_visits? HRPatientsInfo?.earned_revenue_from_visits : 0.00}</span></p>
            <p>Potential Reimbursement: <span>${HRPatientsInfo?.expected_total_revenue ? HRPatientsInfo?.expected_total_revenue : 0.00}</span></p>
          </div>
          <hr />
          <div className="highrisk_card_bottom">
            <Goal size={18} color="#369eff" />&nbsp;<strong>Action: </strong> <span>Assign a Staff to call or Text these patients to schedule a visit</span>
          </div>
        </>
      )}
    </div>
  );
}